import axios from 'axios';
import requestInterceptor from './interceptors/request';
import responseInterceptor from './interceptors/response';

const api = axios.create({
  baseURL: process.env.REACT_APP_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

requestInterceptor(api);
responseInterceptor(api);

export default api;
